module.exports = __webpack_public_path__ + "media/images/icons/search-62c1d87a38d2df14f288eb44b06d1f83.svg";